// extracted by mini-css-extract-plugin
export default {"buttons":"Informations_buttons__CsMJk","buttonsList":"Informations_buttonsList__27Zb1"};